import Requisicao from "./RequisicaoService";

class ConfiguracaoService {        
    static async gravar(uuid, valor) {        
        return Requisicao.post('configuracao', {
            uuid: uuid,
            valor: valor
        });
    }    
}

export default ConfiguracaoService;